export enum LOCAL_NOTIFICATION_ACTION_TYPE {
  ACTIVITY_LOG = 1,
  LOCATION_TRACKING = 2,
  OUT_OF_BOUNDS = 3,
}

export enum LOCAL_NOTIFICATION_SOUND {
  BEEP = 'beep.wav',
}

export enum TOAST_DURATION {
  SHORT = 2000,
  MEDIUM = 3000,
  LONG = 5000,
}

export enum TOAST_CLASS {
  SUCCESS = 'form-submit-toast-success',
  WARNING = 'form-submit-toast-warning',
  DANGER = 'form-submit-toast-danger',
}

export enum TOAST_POSITION {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}

export enum ALERT_BUTTON_CLASS {
  DEFAULT = 'form-alert-default',
  SUCCESS = 'form-alert-success',
  WARNING = 'form-alert-warning',
  DANGER = 'form-alert-danger',
}
